<template>
	<div :class="classes" :style="cssVars"></div>
</template>

<script>
export default {
	name: 'Block',
	props: {
		active: {
			type: Boolean,
			default: false,
		},
		pos: Object,
	},
	inject: ['board'],
	data() {
		return { name: 'block' }
	},
	computed: {
		classes() {
			return [
				this.name,
				{ [`${this.name}--active`]: this.active },
			]
		},
		cssVars() {
			return {
				'--left': `${this.pos.x}`,
				'--top': `${this.pos.y}`,
			}
		},
	},
	methods: {
		checkCollision(x, y) {
			// bound
			if (0 > x || x >= 10 || y >= 22) return true
			if (y < 0) return false
			return this.board[y][x]
		},
	},
}
</script>

<style lang="scss">
$block-margin: calc($block-size * 0.0625);
.block {
	width: calc($block-size - $block-margin * 2);
	height: calc($block-size - $block-margin * 2);
	background-color: #555;
	margin: $block-margin;
	position: absolute;
	left: calc(var(--left) * $block-size);
	top: calc(var(--top) * $block-size);

	&--active {
		background-color: #777;
		z-index: 1;
	}
}
</style>
